import { getTenantSlug } from './paths';

function isLocalStorageAvailable() {
    try {
        const test = '__storage_test__';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

const memoryStorage = {};
const available = isLocalStorageAvailable();

// Prefija la clave con el slug del tenant para aislar datos entre clientes
// que comparten dominio (ej: 'micliente:cart' vs 'cart' en la demo).
function conPrefijo(key) {
    const slug = getTenantSlug();
    return slug ? `${slug}:${key}` : key;
}

const storage = {
    getItem(key) {
        const k = conPrefijo(key);
        if (available) return localStorage.getItem(k);
        return memoryStorage[k] || null;
    },
    setItem(key, value) {
        const k = conPrefijo(key);
        if (available) localStorage.setItem(k, value);
        else memoryStorage[k] = value;
    },
    removeItem(key) {
        const k = conPrefijo(key);
        if (available) localStorage.removeItem(k);
        else delete memoryStorage[k];
    }
};

export default storage;
